import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Dashboard from "@/pages/Dashboard";
import CaptureBill from "@/pages/CaptureBill";
import BillDetail from "@/pages/BillDetail";
import Receipt from "@/pages/Receipt";
import PublicPay from "@/pages/PublicPay";
import IncomePage from "@/pages/Income";
import WeeklyPage from "@/pages/Weekly";
import EmbedPage from "@/pages/Embed";
import ReceiptsPage from "@/pages/Receipts";
import CaptureReceipt from "@/pages/CaptureReceipt";
import ReceiptDetail from "@/pages/ReceiptDetail";
import ReceiptsExport from "@/pages/ReceiptsExport";
import SmartCapture from "@/pages/SmartCapture";
import AllocateTransaction from "@/pages/AllocateTransaction";
import CaptureQuote from "@/pages/CaptureQuote";
import WeeklyForecast from "@/pages/WeeklyForecast";
import WeeklyPrint from "@/pages/WeeklyPrint";
import StatementPrint from "@/pages/StatementPrint";
import Guide from "@/pages/Guide";
import CalendarView from "@/pages/CalendarView";
import { JobsList, JobDetail } from "@/pages/Jobs";
import PnLPage from "@/pages/PnL";
import HistoryPage from "@/pages/HistoryPage";
import BankStatementPage from "@/pages/BankStatement";
import AllocatePage from "@/pages/Allocate";
import GrowPage from "@/pages/Grow";
import OverheadsPage from "@/pages/Overheads";
import Manual from "@/pages/Manual";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/pay/:id" element={<PublicPay />} />
            <Route path="/bills/:id/receipt" element={<Receipt />} />

            {/* Protected routes — login required */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/bills" element={<Dashboard />} />
              <Route path="/snap" element={<SmartCapture />} />
              <Route path="/allocate" element={<AllocateTransaction />} />
              <Route path="/income/from-quote" element={<CaptureQuote />} />
              <Route path="/new" element={<CaptureBill />} />
              <Route path="/bills/:id" element={<BillDetail />} />
              <Route path="/income" element={<IncomePage />} />
              <Route path="/weekly" element={<WeeklyPage />} />
              <Route path="/weekly/forecast" element={<WeeklyForecast />} />
              <Route path="/weekly/print" element={<WeeklyPrint />} />
              <Route path="/statement" element={<StatementPrint />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/calendar" element={<CalendarView />} />
              <Route path="/jobs" element={<JobsList />} />
              <Route path="/jobs/:tag" element={<JobDetail />} />
              <Route path="/pnl" element={<PnLPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/bank-statement" element={<BankStatementPage />} />
              <Route path="/allocate-weekly" element={<AllocatePage />} />
              <Route path="/grow" element={<GrowPage />} />
              <Route path="/overheads" element={<OverheadsPage />} />
              <Route path="/manual" element={<Manual />} />
              <Route path="/embed" element={<EmbedPage />} />
              <Route path="/receipts" element={<ReceiptsPage />} />
              <Route path="/receipts/new" element={<CaptureReceipt />} />
              <Route path="/receipts/export" element={<ReceiptsExport />} />
              <Route path="/receipts/:id" element={<ReceiptDetail />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
